const directUpload = () => {
   
  addEventListener("direct-upload:progress", event => {
    const { id, progress } = event.detail
    const element = document.getElementById(`upload-progress`)
    element.innerText = `${Math.round((Math.round(progress)/100)*95)}%`
  })

  addEventListener("direct-upload:end", event => {
    const progressButton = document.getElementById(`upload-progress`)
    progressButton.innerText = `${96 + _.random(0,2)}%`
  })
  
 addEventListener("direct-upload:error", event => {
   event.preventDefault()
   const element = document.getElementById(`upload-progress`)
   element.innerText = `, une erreur s'est produite.`
 })
  
}

export { directUpload };